import { Box, Stack } from "@mui/material"
import { usePathname } from "next/navigation"
import { FC, useEffect } from "react"

import { StandBookingSelection } from "src/components/services/account/overview/StandBookingSelection"
import { create } from "src/helpers/bem"
import { getPath } from "src/helpers/paths"
import { useLocale } from "src/states/locale"
import { SharedPageProps } from "src/types/SharedPageProps"

import { AccountNavigation } from "./AccountNavigation"
import styles from "./AccountOverview.module.scss"
import { SubHeader } from "./SubHeader"

const bem = create(styles, "AccountOverview")

export const AccountOverview: FC<SharedPageProps> = ({
  messages,
  children,
}) => {
  const locale = useLocale()
  const pathname = usePathname()

  useEffect(() => {}, [locale])

  return (
    <Stack
      className={bem("AccountOverview")}
      direction={"column"}
      spacing={8.125}
    >
      <SubHeader
        accountArea
        homeButton={pathname === getPath(locale, "account")}
        additionals={
          pathname === getPath(locale, "account") ? undefined : (
            <StandBookingSelection messages={messages} />
          )
        }
      />
      <Stack className={bem("contentWrapper")} direction={"row"} gap={1}>
        <AccountNavigation />
        <Box className={bem("content")}>{children}</Box>
      </Stack>
    </Stack>
  )
}
 